import { Box } from '@chakra-ui/react'
import React from 'react'

import { CircleBadgeVariant } from './componentStyles/CircleBadge.style'
import { usePulsingCircleBadgeStyle } from './componentStyles/PulsingCircleBadge.style'

interface PulsingCircleBadgeProps {
  variant: CircleBadgeVariant
}
export const PulsingCircleBadge = ({ variant }: PulsingCircleBadgeProps) => {
  const style = usePulsingCircleBadgeStyle({ variant })
  return <Box css={style} />
}
